import { lazy as lazyLoad } from 'react';

import { route } from '../profile/constants';

import type { RouteDefinition } from '../../route';

const lazy = {
    EditAboutMePage: lazyLoad(async () => {
        const { EditAboutMe } = await import('./EditAboutMe');

        return { default: EditAboutMe };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.recruiter-profile.about-me.title',
        page: lazy.EditAboutMePage,
        path: route.patterns.individualUser.aboutMe.edit,
    },
];
